import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { ReconciliationModule } from '../../modules/reconciliation/ReconciliationModule.tsx';

export const ReconciliationRouteElement = () => (
  <ModuleContainer moduleID="reconciliation" compact>
    <ReconciliationModule />
  </ModuleContainer>
);
